import terms from './searchTerms';

const menuStructure = [
    {
        title: 'Home',
        link: '/',
        icon: 'home',
        terms: terms.home,
    },
    {
        title: 'Dados da empresa',
        link: '/dados_empresa',
        icon: 'leaderboard',

        childrens: [
            {
                title: 'Informações de cadastro',
                link: '/informacoes',
                terms: terms.informacoesCadastro,
            },
            {
                title: 'Gerenciar usuários',
                link: '/gerenciar_usuarios',
                terms: terms.gerenciarUsuarios,
            },
            {
                title: 'Alterar senha',
                link: '/alterar_senha',
                externalLink: process.env.REACT_APP_CHANGE_PASSWORD_URL,
                terms: terms.alterarSenha,
            },
            {
                title: 'Pesquisa congêneres',
                link: '/pesquisa_congeneres',
            },
        ],
    },
    {
        title: 'Dados do contrato',
        link: '/dados_contrato',
        icon: 'description',

        childrens: [
            {
                title: 'Carta de reajuste',
                link: '/carta_reajuste',
                terms: terms.cartaReajuste,
            },
            {
                title: 'Consultar planos e valores',
                link: '/planos_valores',
                terms: terms.consultaPlanosValores,
            },
            {
                title: 'Histórico carta de reajuste',
                link: '/hist_carta_reajuste',
                billingRedirectURLKey: 'plinkExtr',
                redirectDomain: process.env.REACT_APP_HIST_READJUSTMENT_DOMAIN,
            },
        ],
    },
    {
        title: 'Dados de beneficiário',
        link: '/dados_beneficiario',
        icon: 'person',

        childrens: [
            {
                title: 'Consultar beneficiário',
                link: '/selecionar_beneficiario_dados',
                terms: terms.consultarBeneficiario,
            },
            {
                title: 'Carteirinha',
                link: '/selecionar_acao',
            },
            // {
            //     title: 'Lista de solicitações',
            //     link: '/lista_solicitacoes',
            // },
            {
                title: 'Relatório de beneficiários',
                link: '/relatorio_beneficiarios',
                terms: terms.relatorioBeneficiarios,
            },
            {
                title: 'Serviços do beneficiário',
                link: '/servico_do_beneficiario',
                externalLink: process.env.REACT_APP_HEALTH_SERVICES_ONLINE_URL,
            },
            {
                title: 'Carta de permanência',
                link: '/carta_de_permanencia',
                terms: terms.relatorioBeneficiarios,
            },
            {
                title: 'Demonstrativo de imposto de renda',
                link: '/seleciona_beneficiario_imposto_renda',
                terms: terms.demonstrativoImpostoRenda,
            },
            {
                title: 'Demonstrativo de Coparticipação',
                link: '/seleciona_beneficiario_coparticipacao',
                terms: terms.demonstrativoCoparticipacao,
            },
            {
                title: 'Tabela franquia',
                link: '/selecionar_beneficiario_franquia',
                terms: terms.tabelaFranquia,
            },
            {
                title: 'Guia médica',
                link: '/guias',
                terms: terms.solicitacaoGuias,
            },
            {
                title: 'Agendamento de consulta',
                link: '/consulta_beneficiario_eventual',
                terms: terms.consultaBeneficiarioEventual,
            },
            {
                title: 'Pesquisa de Rede',
                link: '/pesquisa_rede',
                terms: terms.pesquisaRede,
            },
            // {
            //     title: 'Beneficiários por período',
            //     link: '/beneficiarios_periodo',
            // },
        ],
    },
    {
        title: 'Movimentação cadastral',
        link: '/movimentacao_cadastral',
        icon: 'swap_horiz',

        childrens: [
            {
                title: 'Adicionar beneficiário',
                link: '/adicionar_beneficiario',
                terms: terms.adicionarBeneficiario,
            },
            {
                title: 'Alterar beneficiário',
                link: '/selecionar_alterar_beneficiario',
                terms: terms.alterarBeneficiario,
            },
            {
                title: 'Trocar o plano',
                link: '/selecionar_trocar_plano',
                terms: terms.trocarPlano,
            },
            {
                title: 'Transferir beneficiário',
                link: '/selecionar_transferencia_beneficiario',
                terms: terms.transferirBeneficiario,
            },
            {
                title: 'Desligar beneficiário',
                link: '/selecionar_desligar_beneficiario',
                terms: terms.desligarBeneficiario,
            },
            {
                title: 'Reativar beneficiário',
                link: '/selecionar_reativar_beneficiario',
                terms: terms.reativarBeneficiario,
            },
            {
                title: 'Aposentados e demitidos',
                link: '/selecionar_aposentados_demitidos',
                terms: terms.aposentadosDemitidos,
            },
            // {
            //     title: 'Falecimento de titular',
            //     link: '/falecimento_titular',
            //     terms: terms.falecimentoTitular,
            // },
            {
                title: 'Movimentações pendentes',
                link: '/movimentacoes_pendentes',
                terms: terms.movimentacoesPendentes,
            },
            {
                title: 'Movimentações por arquivo',
                link: '/movimentacoes_arquivo',
                terms: terms.movimentacaoPorArquivo,
            },
            {
                title: 'Histórico de movimentação',
                link: '/historico_movimentacao',
                terms: terms.historicoMovimentacao,
            },
            {
                title: 'Centro de custo',
                link: '/selecionar_centro_custo',
                terms: terms.centroCusto,
            },
            {
                title: 'Lotação',
                link: '/selecionar_lotacao',
                terms: terms.lotacao,
            },
        ],
    },
    {
        title: 'Faturamento',
        link: '/faturamento',
        icon: 'description',
        childrens: [
            {
                title: 'Consultar faturas',
                link: '/consultar_faturas',
                terms: terms.consultarFaturas,
            },
            {
                title: 'Informe de rendimento',
                link: '/informe_rendimento',
                billingRedirectURLKey: 'plinkRend',
                redirectDomain: process.env.REACT_APP_INCOME_REPORT_DOMAIN,
            },
            {
                title: 'Coparticipação',
                link: '/coparticipacao',
                billingRedirectURLKey: 'plinkCoop',
                redirectDomain: process.env.REACT_APP_COPARTICIPATION_DOMAIN,
            },
            {
                title: 'Registro de acidentados',
                link: '/registro_acidentados',
                externalLink: process.env.REACT_APP_ACCIDENT_RECORD_URL,
            },
            // {
            //     title: 'Declaração de quitação de débitos',
            //     link: '/declaracao_quitacao_debitos',
            // },
        ],
    },
    {
        title: 'Central de ajuda',
        link: '/central_ajuda',
        icon: 'help_outline',
        childrens: [
            {
                title: 'Materiais de apoio',
                link: '/materiais_apoio',
            },
        ],
    },
];

export default menuStructure;
